import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';
import { ValidatedForm, FormChoice, FormSubmit } from './common/ValidatedForm';
import { updateAdminTypeClientSchema } from '../shared/validations/userValidations';
import { PayrollAdminType } from '../shared/constants/userConstants.js';
import { useAuth } from '../utils/AuthContext.js';

const PayrollAdminTypeForm = ({ onFinish }) => {
  const { lang, optionsForEnum } = useLanguage(translations);
  const { user, api } = useAuth();

  const { isThirdPartyPayrollAdmin } = user;

  const payrollAdminType =
    isThirdPartyPayrollAdmin === true
      ? PayrollAdminType.THIRD_PARTY
      : isThirdPartyPayrollAdmin === false
      ? PayrollAdminType.IN_HOUSE
      : undefined;

  const handleSubmit = async ({ payrollAdminType }) => {
    const isThirdPartyPayrollAdmin =
      payrollAdminType === PayrollAdminType.THIRD_PARTY
        ? true
        : payrollAdminType === PayrollAdminType.IN_HOUSE
        ? false
        : undefined;

    await api.updateUserIsThirdPartyPayrollAdmin({ isThirdPartyPayrollAdmin });
  };
  return (
    <ValidatedForm
      key="payrollAdminType"
      schema={updateAdminTypeClientSchema}
      initialValues={{ payrollAdminType }}
      handleSubmit={handleSubmit}
      onFinish={onFinish}
    >
      <FormChoice name="payrollAdminType" options={optionsForEnum(PayrollAdminType)} type="button" />
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default PayrollAdminTypeForm;
